var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.badges.length > 0)?_c('div',{staticClass:"badges"},_vm._l((_vm.badges),function(badge,index){return _c('div',{key:index,staticClass:"badge",class:badge.style},[_vm._v(_vm._s(badge.symbol))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }